export function isFormDirty(current, initial) {
  return JSON.stringify(current) !== JSON.stringify(initial);
}
